import { Button } from "@hoylu/client-common";
import React, { useRef, useState } from "react";
import { Localized } from "../../../strings";
import { sendEmail } from "../../../utils/sharing.helpers";
import { TextCopier } from "../../../utils/text.copier";
import Styles from "./CopyEmailLink.module.css";

type CopyEmailLinkProps = {
  workspaceName?: string;
  shareLink: string;
};

export const CopyEmailLink: React.FC<CopyEmailLinkProps> = ({
  workspaceName,
  shareLink,
}) => {
  const strings = Localized.object("COPY_EMAIL_LINK");
  const [copyClicked, setCopyClicked] = useState(false);
  const shareLinkRef = useRef<HTMLSpanElement>(null);

  const copyLink = (): void => {
    setCopyClicked(true);
    const copier = new TextCopier();
    copier.copy(shareLink);
  };

  const isSmall = window.innerWidth < 760;

  const copyText = isSmall
    ? copyClicked
      ? strings.SMALL_COPIED_LINK
      : strings.SMALL_COPY_LINK
    : copyClicked
      ? strings.COPIED_LINK
      : strings.COPY_LINK;
  const emailText = isSmall ? strings.SMALL_EMAIL : strings.EMAIL;

  return (
    <div className={Styles.copyEmailLink}>
      {shareLink && (
        <div className={Styles.description}>
          <span ref={shareLinkRef}>{shareLink.replace("https://", "")}</span>
        </div>
      )}
      <div className={Styles.buttons}>
        <Button
          classNames={[Styles.button]}
          onClick={copyLink}
          toolTip={strings.COPY_WORKSPACE_LINK}
          type="primary"
        >
          {copyText}
        </Button>
        <Button
          classNames={[Styles.button]}
          onClick={() => sendEmail(workspaceName ?? "", shareLink)}
          toolTip={strings.EMAIL_WORKSPACE_LINK}
          type="primary"
        >
          {emailText}
        </Button>
      </div>
    </div>
  );
};
